<script>
	let model = 'chady';

	let index = `00{index}.webp`;
	document.addEventListener("DOMContentLoaded", () => {
		window.CI360.add("xview");
	})
</script>

<center>
	<div class="cloudimage-360 xview" id="xview" data-folder="/models/{model}/" data-filename-x="{ index }" data-amount-x="30"></div>
</center>

<style>
	.xview, * {
		max-width: 100vh;
	}
</style>